import { conversationMediaState } from '../state/ConversationMedia/singleton';

/**
 * @deprecated use useMessageMediaContent instead
 */
export const useConversationMessageMediaContentState = conversationMediaState;
